import { t } from 'i18next'
import React from 'react'
import { any, async, fromJSX, navigate, StandardLocalWidget, Updater } from 'widgets-for-react'
import { datalayerHandler } from '../../cms/blocks/utils/gtm.mod'
import { headerSearchBarFormDatalayer } from '../../datalayer'
import { clickoutside } from '../../helpers'
import { Breadcrumbs } from '../templates/breadcrumbs.mod'
import { Pagination } from '../templates/pagination.mod'
import { getLangFromUrl } from '../utils/history.mod'
import { Loader } from '../utils/loader'
import { add_project_title, updateMetaDescription } from '../widget'
import { Articles, Vacancies } from './overview_items_block'
import { OverviewState, Tags } from './state'
import {
  encodeTag,
  newsTypeTags,
  PageKind,
  pageKindToSlug,
  resourceIndustryTags,
  resourceTypeTags,
  tagUrlParameter,
  teamMemberDiscipline,
  testimonialTags,
  translatedCareersSlug,
  translatedCareersTitle,
  vacancyContract,
  vacancyCountry,
  vacancyDepartment,
  vacancyLocation,
  vacancyStateProvince
} from './utils'

//TODO: CHECK IF THE VACANCY OVERVIEW IS THE ONLY OVERVIEW, IF SO MOVE THIS TO VACANCIES FOLDER
export const overviewWidget: StandardLocalWidget<OverviewState> = ({
  overviewItems,
  overviewPage,
  tags,
  selectedOptions,
  searchValue,
  pageKind,
  showFilters
}) => {
  if (overviewPage.kind == 'loaded') {
    const metatagTitle = overviewPage.value.node.metatag.find((item) =>
      item.attributes?.name == 'title' ||
      item.attributes?.name == 'twitter:title' ||
      item.attributes?.property == 'og:title'
    )?.attributes?.content
    document.title = add_project_title(metatagTitle ?? overviewPage.value.node.label)

    const metatagDescription = overviewPage.value.node.metatag.find((item) =>
      item.attributes?.name == 'description' ||
      item.attributes?.name == 'twitter:description' ||
      item.attributes?.property == 'og:description'
    )?.attributes?.content
    if (metatagDescription) updateMetaDescription(metatagDescription)
  }
  const currentLang = getLangFromUrl()
  const careersSlug = translatedCareersSlug[currentLang]
  const careersTitle = translatedCareersTitle[currentLang]

  return any([
    async(overviewItems).map((updater) => (state): OverviewState => {
      const newState = updater(overviewItems)
      if (newState.kind == 'loaded') {
        if (selectedOptions.searchQuery != undefined && selectedOptions.searchQuery != '')
          datalayerHandler(
            'search',
            newState.value.pager.totalItems > 0 ? 'result' : 'no_result',
            'search_' + pageKind,
            { label: selectedOptions.searchQuery }
          )
      }
      return { ...state, overviewItems: newState }
    }),
    ...tags
      .map((values, key) =>
        async(values, undefined, { key }).map<Updater<OverviewState>>(
          (updater) =>
            (state): OverviewState => ({
              ...state,
              tags: state.tags.set(key, updater(state.tags.get(key)))
            })
        )
      )
      .toArray(),
    fromJSX((setState) => {
      const filterTagChanged = (tags: Tags): void =>
        navigateToNewURL(
          pageKind,
          tags.mapEntries<string, Array<string>>(([k, v]) => [k, v.map((f) => encodeTag(f))]).toMap(),
          selectedOptions.searchQuery,
          0
        )

      if (pageKind == 'vacancy-overview' && selectedOptions.searchQuery.length > 0 && overviewItems.kind == 'loaded')
        headerSearchBarFormDatalayer(
          overviewItems.value.items.count() > 0 ? 'result' : 'no_result',
          selectedOptions.searchQuery
        )

      return (
        <main className="main main--vacancies">
          <header className="pageheader pageheader--flat no-image">
            <div className="pageheader__inner">
              <div className="pageheader__content container container--m">
                <div className="pageheader__message">
                  <div className="pageheader__header">
                    {/* <div className="pageheader__breadcrumbs">
                      <Breadcrumbs
                        breadcrumbs={[
                          { url: `/${currentLang}/`, title: 'Home' },
                          { url: `/${currentLang}/${careersSlug}`, title: `${careersTitle}` },
                          { url: `/${currentLang}/${careersSlug}/vacancies`, title: t('Vacancy:title_our_vacancies') }
                        ]}
                      />
                    </div> */}
                    <h1 className="pageheader__title">{t('Vacancy:title_our_vacancies')}</h1>
                  </div>
                </div>
              </div>
            </div>
          </header>

          <div className="main__inner">
            <article className="page">
              <div className="page__inner">
                <div className="container container--m grid--gutter">
                  <section className="search-bar">
                    <div className="search-bar__inner grid--gutter">
                      <SearchAndTagFilterLayout
                        pageKind={pageKind}
                        tags={tags
                          .mapEntries<string, Array<string>>(([k, v]) => [
                            k,
                            v.kind == 'loaded' || v.kind == 'loading' ? v.value || [] : []
                          ])
                          .toMap()}
                        selectedOptions={selectedOptions}
                        searchValue={searchValue}
                        showFilters={showFilters}
                        toggleFilters={(): void =>
                          setState((state): OverviewState => ({ ...state, showFilters: !state.showFilters }))
                        }
                        filterTagChanged={filterTagChanged}
                        searchValueChanged={(searchValue): void =>
                          setState((state): OverviewState => ({ ...state, searchValue }))
                        }
                        searchSubmitted={(): void =>
                          navigateToNewURL(
                            pageKind,
                            selectedOptions.tags.mapEntries(([k, v]) => [k, v.map((f) => encodeTag(f))]).toMap() as any,
                            searchValue,
                            0
                          )
                        }
                      />
                    </div>
                  </section>
                </div>

                {overviewItems.kind == 'loaded' &&
                  (pageKind == 'news-overview' || pageKind == 'team-overview' || pageKind == 'testimonial-overview' ? (
                    <Articles items={overviewItems.value.items} />
                  ) : (
                    <Vacancies
                      selected_tags={selectedOptions.tags}
                      update_tags={filterTagChanged}
                      items={overviewItems.value.items}
                      items_count={overviewItems.value.pager.totalItems}
                    />
                  ))}

                {overviewItems.kind == 'loaded' && overviewItems.value.pager.totalPages > 1 && (
                  <Pagination
                    pager={{
                      current_page: overviewItems.value.pager.currentPage,
                      items_per_page: overviewItems.value.pager.itemsPerPage,
                      total_items: overviewItems.value.pager.totalItems,
                      total_pages: overviewItems.value.pager.totalPages
                    }}
                    setPage={(page) => {
                      navigateToNewURL(
                        pageKind,
                        selectedOptions.tags
                          .mapEntries<string, Array<string>>(([k, v]) => [k, v.map((f) => encodeTag(f))])
                          .toMap(),
                        selectedOptions.searchQuery,
                        page
                      )
                    }}
                  />
                )}

                {overviewItems.kind == 'loading' ? (
                  <Loader />
                ) : (
                  overviewItems.kind != 'loaded' && <div>{overviewItems.kind}</div>
                )}
              </div>
            </article>
          </div>
        </main>
      )
    })
  ])
}

const navigateToNewURL = (pageKind: PageKind, tags: Tags, searchQuery: string, page: number) => {
  const params: string[] = []

  tags.forEach((values, tag) =>
    values.forEach((value, index) => {
      if (value) params.push(`${tagUrlParameter(tag)}[${index}]=${value}`)
    })
  )

  if (searchQuery) params.push(`searchQuery=${searchQuery}`)

  const lang = getLangFromUrl()

  const newURL = `/${lang}/${translatedCareersSlug[lang]}/${pageKindToSlug(pageKind)}/${page}${
    params.length > 0 ? `/?${params.join('&')}` : ''
  }`

  navigate(newURL)
}

const SearchAndTagFilterLayout = ({
  pageKind,
  tags,
  selectedOptions,
  searchValue,
  searchValueChanged,
  searchSubmitted,
  filterTagChanged,
  showFilters,
  toggleFilters
}: {
  pageKind: PageKind
  tags: Tags
  selectedOptions: { tags: Tags; searchQuery: string; currentPage: number }
  searchValue: string
  searchValueChanged: (searchQuery: string) => void
  showFilters: boolean
  toggleFilters: () => void
  filterTagChanged: (tags: Tags) => void
  searchSubmitted: () => void
}) => {
  const vacancyContractTypeTagValues = tags.get(vacancyContract, [])
  const vacancyCountryTagValueValues = tags.get(vacancyCountry, [])
  const vacancyLocationTagValues = tags.get(vacancyLocation, [])
  const vacancyDepartmentTagValues = tags.get(vacancyDepartment, [])
  const vacancyStateProvinceTagValues = tags.get(vacancyStateProvince, [])
  const filterOverlayInner = React.useRef<HTMLDivElement>(null)

  if (pageKind == 'vacancy-overview') {
    if (showFilters && filterOverlayInner.current) {
      clickoutside(filterOverlayInner.current, () => toggleFilters())
    }
    return (
      <div className="search-bar__pseudo-form">
        <div className="search-bar__form-inner">
          <div className="search-bar__group search-bar__group--primary">
            <label className="search-bar__form-label text--l">{t('search:your_search')}</label>
            <input
              type="search"
              id="search-input"
              name="search"
              inputMode="search"
              className="search-bar__input text--l"
              aria-label={t('search:your_search')}
              value={searchValue}
              onChange={(e) => searchValueChanged(e.target.value)}
              onKeyPress={(e) => {
                if (e.key === 'Enter' || e.keyCode === 13) document.getElementById('search-vacancies-btn').click()
              }}
            />
          </div>
          <div className="search-bar__group search-bar__group--actions">
            <button className="search-bar__button button button--filter" onClick={toggleFilters}>
              <span>{t('search:filter')}</span>
              <img src="/images/icons/arrow-circle--right--orange.svg" alt="" width="24" height="24" />
            </button>
            <button
              id="search-vacancies-btn"
              className="search-bar__button button button--primary"
              form="search-vacancies"
            >
              {t('search:search')}
            </button>
          </div>

          <div className={`filter-overview fo${showFilters ? '' : ' fo--hidden'}`}>
            <div ref={filterOverlayInner} className="fo__inner grid--block">
              <button className="fo__button" onClick={() => toggleFilters()}>
                <span className="sr-text">Closing overlay button</span>
                <img className="languages__logo" src="/images/icons/icon--close--new.svg" alt="" height="30" width="32"/>
              </button>
              <h2 className="fo__title title--xs">{t('search:filter')}</h2>
              <form
                className="fo__form"
                id="search-vacancies"
                onSubmit={(e): void => {
                  e.preventDefault()
                  if (searchValue) datalayerHandler('search', 'search', 'filter_opdrachten', { label: searchValue })
                  searchSubmitted()
                  e.stopPropagation()
                }}
                onReset={(e) => {
                  e.preventDefault()
                  filterTagChanged(
                    selectedOptions.tags
                      .set(vacancyCountry, [])
                      .set(vacancyLocation, [])
                      .set(vacancyDepartment, [])
                      .set(vacancyContract, [])
                  )
                  e.stopPropagation()
                }}
              >
                <ul className="fo__lists">
                  {renderVacancyOverviewCountryTagFilterCheckboxes(
                    vacancyCountryTagValueValues,
                    vacancyCountry,
                    vacancyOverviewTagFilterTitle(vacancyCountry),
                    selectedOptions,
                    filterTagChanged
                  )}
                  {renderVacancyOverviewStateProvinceTagFilterCheckboxes(
                    vacancyStateProvinceTagValues,
                    vacancyStateProvince,
                    vacancyOverviewTagFilterTitle(vacancyStateProvince),
                    selectedOptions,
                    filterTagChanged
                  )}
                  {renderVacancyOverviewLocationTagFilterCheckboxes(
                    vacancyLocationTagValues,
                    vacancyLocation,
                    selectedOptions,
                    filterTagChanged
                  )}
                  {renderVacancyOverviewDepartmentTagFilterCheckboxes(
                    vacancyDepartmentTagValues,
                    vacancyDepartment,
                    vacancyOverviewTagFilterTitle(vacancyDepartment),
                    selectedOptions,
                    filterTagChanged
                  )}
                  {renderVacancyOverviewContractTagFilterCheckboxes(
                    vacancyContractTypeTagValues,
                    vacancyContract,
                    selectedOptions,
                    filterTagChanged
                  )}
                </ul>

                <div className="fo__bottom">
                  <div className="fo__icon"></div>
                  <div className="fo__actions">
                    <button type="submit" className="button button--primary" onClick={() => toggleFilters()}>
                      {t('search:show_vacancies')}
                    </button>
                    <button type="reset" className="link link--secondary">
                      {t('search:reset_filters')}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    )
  }

  const newsTypeTagValues = tags.get(newsTypeTags, [])
  const selectedNewsTypeTagValues = selectedOptions.tags.get(newsTypeTags, [])

  if (pageKind == 'news-overview')
    return (
      <div className="block__filters hidden">
        <form
          onSubmit={(e) => {
            e.preventDefault()
            searchSubmitted()
          }}
          className="block__form"
        >
          <div className="pageheader__form form__group--100">
            <input
              aria-label="Search"
              className="pageheader__input"
              type="search"
              placeholder="Blog, Event, Nieuws, etc."
              value={searchValue}
              onChange={(e): void => searchValueChanged(e.target.value)}
            ></input>
            <svg aria-hidden="true" className="pageheader__inputicon" width="20px" height="20px">
              <use xlinkHref="#icon--search" />
            </svg>
          </div>

          <h3 className="filters__title title--m form__group--100">Story type</h3>
          {(newsTypeTagValues || []).length > 0 ? (
            <div className="form__group form__group--100">
              <div className="form__select">
                <select
                  name="select1"
                  id="select1"
                  value={selectedNewsTypeTagValues}
                  onChange={(event) => {
                    datalayerHandler('actueel', 'type', 'filter_story', { label: event.target.value })
                    filterTagChanged(selectedOptions.tags.set(newsTypeTags, [event.target.value]))
                  }}
                >
                  <option value="">{t('search:all_types')}</option>
                  {newsTypeTagValues.map((tag) => (
                    <option value={tag}>{tag}</option>
                  ))}
                </select>
              </div>
            </div>
          ) : null}
          <footer className="form__footer form__group form__group--100">
            <button type="submit" className="button button--primary">
              <span>Stories filteren</span>
            </button>
          </footer>
        </form>
      </div>
    )

  if (pageKind == 'team-overview') {
    const teamMemberDisciplineTagValues = tags.get(teamMemberDiscipline, [])
    return (
      <div className="block__filters hidden">
        <form
          className="block__form"
          onSubmit={(e) => {
            e.preventDefault()
            searchSubmitted()
          }}
        >
          <h3 className="filters__title title--m form__group--100">Discipline</h3>
          {(teamMemberDisciplineTagValues || []).map((discipline) => (
            <div className="form__group form__group--50 form__group--bool form__group--checkbox">
              <input
                id={`check1 ${discipline}`}
                key={`check1 ${discipline}`}
                type="checkbox"
                className="form__bool form__checkbox"
                checked={selectedOptions.tags.get(teamMemberDiscipline)?.includes(discipline)}
                onClick={() => {
                  const selected_disciplines = selectedOptions.tags.get(teamMemberDiscipline)
                  if (selected_disciplines.includes(discipline)) {
                    filterTagChanged(
                      selectedOptions.tags.set(
                        teamMemberDiscipline,
                        selected_disciplines.filter((d) => d != discipline)
                      )
                    )
                  } else
                    filterTagChanged(
                      selectedOptions.tags.set(teamMemberDiscipline, selected_disciplines.concat(discipline))
                    )
                }}
              />
              <label htmlFor={`check1 ${discipline}`} className="form__label text--m">
                {discipline}
              </label>
            </div>
          ))}
          <footer className="form__footer form__group form__group--100">
            <button type="submit" className="button button--primary">
              <span>Team leden filteren</span>
            </button>
          </footer>
        </form>
      </div>
    )
  }

  if (pageKind == 'testimonial-overview') {
    const testimonialsTagValues = tags.get(testimonialTags, [])
    const selectedTestimonialsTagValues = selectedOptions.tags.get(testimonialTags, [])
    return (
      <div className="block__filters hidden">
        <form
          onSubmit={(e) => {
            e.preventDefault()
            searchSubmitted()
          }}
          className="block__form"
        >
          <h3 className="filters__title title--m form__group--100">Testimonial type</h3>
          {(testimonialsTagValues || []).length > 0 && (
            <div className="form__group form__group--100">
              <div className="form__select">
                <select
                  name="select1"
                  id="select1"
                  value={selectedTestimonialsTagValues}
                  onChange={(event) => {
                    filterTagChanged(selectedOptions.tags.set(testimonialTags, [event.target.value]))
                  }}
                >
                  <option value="">All testimonials</option>
                  {testimonialsTagValues.map((tag) => (
                    <option value={tag}>{tag}</option>
                  ))}
                </select>
              </div>
            </div>
          )}
          <footer className="form__footer form__group form__group--100">
            <button type="submit" className="button button--primary">
              <span>Testimonials filteren</span>
            </button>
          </footer>
        </form>
      </div>
    )
  }

  const resourceIndustryTagValues = tags.get(resourceIndustryTags, [])
  const selectedResourceIndustryTagValues = selectedOptions.tags.get(resourceIndustryTags, [])
  const resourceTypeTagValues = tags.get(resourceTypeTags, [])
  const selectedResourceTypeTagValues = selectedOptions.tags.get(resourceTypeTags, [])

  const selected_vacancyContractTypeTags = selectedOptions.tags.get(vacancyContract, [])
  const selected_vacancyCountryTags = selectedOptions.tags.get(vacancyCountry, [])
  const selected_vacancyStateProvinceTags = selectedOptions.tags.get(vacancyStateProvince, [])
  const selected_vacancyLocationTags = selectedOptions.tags.get(vacancyLocation, [])
  const selected_vacancyDepartmentTags = selectedOptions.tags.get(vacancyDepartment, [])
  return (
    <section className="filter container--m gutter--m" aria-label="Filter resources">
      <ul className="filter__list">
        <li className="filter__item filter__item--search">
          <form
            role="search"
            id="resource-search"
            className="form--search"
            onSubmit={(e) => {
              e.preventDefault()
              searchSubmitted()
            }}
          >
            <input
              type="search"
              id="search-input"
              name="search"
              inputMode="search"
              className="search__input form__input"
              aria-label={t('search:your_search')}
              placeholder={t('search:your_search')}
              value={searchValue}
              onChange={(e): void => searchValueChanged(e.target.value)}
            />
            <button type="submit" className="search__submit" title="Search">
              <span className="sr-text">{t('search:search')}</span>
              <svg width="18px" height="18px" aria-hidden="true">
                <use xlinkHref="#icon--search" />
              </svg>
            </button>
          </form>
        </li>
        {resourceIndustryTagValues.length > 0 && (
          <li className="filter__item">
            <div className="form__select">
              <select
                name="resource-filter-industry"
                id="resource-filter-industry"
                disabled={false}
                value={selectedResourceIndustryTagValues}
                onChange={(event) =>
                  filterTagChanged(selectedOptions.tags.set(resourceIndustryTags, [event.target.value]))
                }
              >
                <option value="">{t('search:all_industries')}</option>
                {resourceIndustryTagValues.map((tag) => (
                  <option value={tag}>{tag}</option>
                ))}
              </select>
            </div>
          </li>
        )}
        {resourceTypeTagValues.length > 0 && (
          <li className="filter__item">
            <div className="form__select">
              <select
                name="resource-filter-types"
                id="resource-filter-types"
                disabled={false}
                value={selectedResourceTypeTagValues}
                onChange={(event) => filterTagChanged(selectedOptions.tags.set(resourceTypeTags, [event.target.value]))}
              >
                <option value="">{t('search:all_types')}</option>
                {resourceTypeTagValues.map((tag) => (
                  <option value={tag}>{tag}</option>
                ))}
              </select>
            </div>
          </li>
        )}
        {newsTypeTagValues.length > 0 && (
          <li className="filter__item">
            <div className="form__select">
              <select
                name="news-filter-types"
                id="news-filter-types"
                disabled={false}
                value={selectedNewsTypeTagValues}
                onChange={(event) => filterTagChanged(selectedOptions.tags.set(newsTypeTags, [event.target.value]))}
              >
                <option value="">{t('search:all_types')}</option>
                {newsTypeTagValues.map((tag) => (
                  <option value={tag}>{tag}</option>
                ))}
              </select>
            </div>
          </li>
        )}
        {vacancyContractTypeTagValues.length > 0 && (
          <li className="filter__item">
            <div className="form__select">
              <select
                name="opdract-filter-contract-types"
                id="opdracht-filter-contract-types"
                disabled={false}
                value={selected_vacancyContractTypeTags}
                onChange={(event) => filterTagChanged(selectedOptions.tags.set(vacancyContract, [event.target.value]))}
              >
                <option value="">All contract types</option>
                {vacancyContractTypeTagValues.map((tag) => (
                  <option value={tag}>{tag}</option>
                ))}
              </select>
            </div>
          </li>
        )}
        {vacancyCountryTagValueValues.length > 0 && (
          <li className="filter__item">
            <div className="form__select">
              <select
                name="opdracht-filter-country-types"
                id="opdracht-filter-country-types"
                disabled={false}
                value={selected_vacancyCountryTags}
                onChange={(event) => {
                  filterTagChanged(selectedOptions.tags.set(vacancyCountry, [event.target.value]))
                }}
              >
                <option value="">All countries</option>
                {vacancyCountryTagValueValues.map((tag) => (
                  <option value={tag}>{tag}</option>
                ))}
              </select>
            </div>
          </li>
        )}

        {vacancyStateProvinceTagValues.length > 0 && (
          <li className="filter__item">
            <div className="form__select">
              <select
                name="opdracht-filter-stateprovince-types"
                id="opdracht-filter-stateprovince-types"
                disabled={false}
                value={selected_vacancyStateProvinceTags}
                onChange={(event) => {
                  filterTagChanged(selectedOptions.tags.set(vacancyStateProvince, [event.target.value]))
                }}
              >
                <option value="">All state/provinces</option>
                {vacancyStateProvinceTagValues.map((tag) => (
                  <option value={tag}>{tag}</option>
                ))}
              </select>
            </div>
          </li>
        )}

        {vacancyLocationTagValues.length > 0 && (
          <li className="filter__item">
            <div className="form__select">
              <select
                name="opdracht-filter-location-types"
                id="opdracht-filter-location-types"
                disabled={false}
                value={selected_vacancyLocationTags}
                onChange={(event) => {
                  filterTagChanged(selectedOptions.tags.set(vacancyLocation, [event.target.value]))
                }}
              >
                <option value="">All Locations</option>
                {vacancyLocationTagValues.map((tag) => (
                  <option value={tag}>{tag}</option>
                ))}
              </select>
            </div>
          </li>
        )}
        {vacancyDepartmentTagValues.length > 0 && (
          <li className="filter__item">
            <div className="form__select">
              <select
                name="opdracht-filter-department-types"
                id="opdracht-filter-department-types"
                disabled={false}
                value={selected_vacancyDepartmentTags}
                onChange={(event) => {
                  filterTagChanged(selectedOptions.tags.set(vacancyDepartment, [event.target.value]))
                }}
              >
                <option value="">All Departments</option>
                {vacancyDepartmentTagValues.map((tag) => (
                  <option value={tag}>{tag}</option>
                ))}
              </select>
            </div>
          </li>
        )}
      </ul>
    </section>
  )
}

let take = (l: any[], amount) => {
  if (amount > l.length) return l
  return l.slice(0, amount)
}

let skip = (l: any[], amount) => {
  if (amount > l.length) return []
  return l.slice(amount)
}

const vacancyOverviewTagFilterTitle = (tagType: string) => {
  switch (tagType) {
    case vacancyContract:
      return 'Contract'
    case vacancyCountry:
      return 'Country'
    case vacancyLocation:
      return 'Location'
    case vacancyDepartment:
      return 'Department'
    case vacancyStateProvince:
      return 'State/Province'
    default:
      return ''
  }
}

let btnShowMoreLocation = false
let btnShowMoreCountry = false
let btnShowMoreDepartment = false
let btnShowMoreStateProvince = false
let btnShowMoreContract = false

const renderVacancyOverviewContractTagFilterCheckboxes = (
  tagValues: Array<string>,
  tagType: string,
  selectedOptions: { tags: Tags; searchQuery: string; currentPage: number },
  filterTagChanged: (tags: Tags) => void
) => {
  const tagTitle = vacancyOverviewTagFilterTitle(tagType)
  const selected_tagItems = selectedOptions.tags.get(tagType).sort()

  const nonselected = tagValues.filter((v) => !selected_tagItems.includes(v))

  const newTagValues = [...selected_tagItems, ...nonselected]

  return (
    <li className="fo__items">
      <h3 className="fo__section text--m"> {t(`search:tag_${tagTitle.toLowerCase()}`)}</h3>
      <ul className="fo__list">
        {take(newTagValues, 4).map((tagValue) =>
          renderSingleCheckboxes(tagValue, tagType, tagTitle, selectedOptions, filterTagChanged, '', true)
        )}
        {newTagValues.length > 4 &&
          skip(newTagValues, 4).map((tagValue) =>
            renderSingleCheckboxes(
              tagValue,
              tagType,
              tagTitle,
              selectedOptions,
              filterTagChanged,
              ` fo__item--${tagTitle.toLowerCase()} ${btnShowMoreContract ? '' : 'fo__item--hidden'}`,
              true
            )
          )}
      </ul>
      {tagValues.length > 4 && (
        <button
          id={`btn_${tagTitle.toLowerCase()}`}
          className="fo__toggle link link--secondary"
          onClick={(e) => {
            document.querySelectorAll(`.fo__item--${tagTitle.toLowerCase()}`).forEach((i) => {
              if (i.classList.contains('fo__item--hidden')) {
                i.classList.remove('fo__item--hidden')
                if (!btnShowMoreContract) {
                  btnShowMoreContract = true
                }
              } else {
                i.classList.add('fo__item--hidden')
                if (btnShowMoreContract) {
                  btnShowMoreContract = false
                }
              }
            })
            !btnShowMoreContract
              ? (document.getElementById(`btn_${tagTitle.toLowerCase()}`).innerText = t('search:show_more'))
              : (document.getElementById(`btn_${tagTitle.toLowerCase()}`).innerText = t('search:show_less'))
          }}
        >
          {btnShowMoreDepartment ? t('search:show_less') : t('search:show_more')}
        </button>
      )}
    </li>
  )
}
const renderVacancyOverviewDepartmentTagFilterCheckboxes = (
  tagValues: Array<string>,
  tagType: string,
  tagTitle: string,
  selectedOptions: { tags: Tags; searchQuery: string; currentPage: number },
  filterTagChanged: (tags: Tags) => void
) => {
  const selected_tagItems = selectedOptions.tags.get(tagType).sort()

  const nonselected = tagValues.filter((v) => !selected_tagItems.includes(v))

  const newTagValues = [...selected_tagItems, ...nonselected]

  return (
    <li className="fo__items">
      <h3 className="fo__section text--m"> {t(`search:tag_${tagTitle.toLowerCase()}`)}</h3>
      <ul className="fo__list">
        {take(newTagValues, 4).map((tagValue) =>
          renderSingleCheckboxes(tagValue, tagType, tagTitle, selectedOptions, filterTagChanged, '', true)
        )}
        {newTagValues.length > 4 && (
          <>
            {skip(newTagValues, 4).map((tagValue) =>
              renderSingleCheckboxes(
                tagValue,
                tagType,
                tagTitle,
                selectedOptions,
                filterTagChanged,
                ` fo__item--${tagTitle.toLowerCase()} ${btnShowMoreDepartment ? '' : 'fo__item--hidden'}`,
                true
              )
            )}
          </>
        )}
      </ul>
      {tagValues.length > 4 && (
        <button
          id={`btn_${tagTitle.toLowerCase()}`}
          className="fo__toggle link link--secondary"
          onClick={(e) => {
            document.querySelectorAll(`.fo__item--${tagTitle.toLowerCase()}`).forEach((i) => {
              if (i.classList.contains('fo__item--hidden')) {
                i.classList.remove('fo__item--hidden')
                if (!btnShowMoreDepartment) {
                  btnShowMoreDepartment = true
                }
              } else {
                i.classList.add('fo__item--hidden')
                if (btnShowMoreDepartment) {
                  btnShowMoreDepartment = false
                }
              }
            })
            !btnShowMoreDepartment
              ? (document.getElementById(`btn_${tagTitle.toLowerCase()}`).innerText = t('search:show_more'))
              : (document.getElementById(`btn_${tagTitle.toLowerCase()}`).innerText = t('search:show_less'))
          }}
        >
          {btnShowMoreDepartment ? t('search:show_less') : t('search:show_more')}
        </button>
      )}
    </li>
  )
}
const renderVacancyOverviewStateProvinceTagFilterCheckboxes = (
  tagValues: Array<string>,
  tagType: string,
  tagTitle: string,
  selectedOptions: { tags: Tags; searchQuery: string; currentPage: number },
  filterTagChanged: (tags: Tags) => void
): JSX.Element => {
  const selected_tagItems = selectedOptions.tags.get(tagType).sort()

  const nonselected = tagValues.filter((v) => !selected_tagItems.includes(v))

  const newTagValues = [...selected_tagItems, ...nonselected]
  return (
    newTagValues.length > 0 && (
      <li className="fo__items">
        <h3 className="fo__section text--m"> {t(`search:tag_${tagTitle.toLowerCase().replace('/', '_')}`)}</h3>
        <ul className="fo__list">
          {take(newTagValues, 4).map((tagValue) =>
            renderSingleCheckboxes(tagValue, tagType, tagTitle, selectedOptions, filterTagChanged, '', false)
          )}
          {newTagValues.length > 4 &&
            skip(newTagValues, 4).map((tagValue) =>
              renderSingleCheckboxes(
                tagValue,
                tagType,
                tagTitle,
                selectedOptions,
                filterTagChanged,
                ` fo__item--${tagTitle.toLowerCase().replace('/', '-')} ${
                  btnShowMoreStateProvince ? '' : 'fo__item--hidden'
                }`,
                false
              )
            )}
        </ul>
        {tagValues.length > 4 && (
          <button
            id={`btn_${tagTitle.toLowerCase()}`}
            className="fo__toggle link link--secondary"
            onClick={(e) => {
              document.querySelectorAll(`.fo__item--${tagTitle.toLowerCase().replace('/', '-')}`).forEach((i) => {
                if (i.classList.contains('fo__item--hidden')) {
                  i.classList.remove('fo__item--hidden')
                  if (!btnShowMoreStateProvince) {
                    btnShowMoreStateProvince = true
                  }
                } else {
                  i.classList.add('fo__item--hidden')
                  if (btnShowMoreStateProvince) {
                    btnShowMoreStateProvince = false
                  }
                }
              })
              !btnShowMoreStateProvince
                ? (document.getElementById(`btn_${tagTitle.toLowerCase()}`).innerText = t('search:show_more'))
                : (document.getElementById(`btn_${tagTitle.toLowerCase()}`).innerText = t('search:show_less'))
            }}
          >
            {btnShowMoreStateProvince ? t('search:show_less') : t('search:show_more')}
          </button>
        )}
      </li>
    )
  )
}
const renderVacancyOverviewLocationTagFilterCheckboxes = (
  tagValues: Array<string>,
  tagType: string,
  selectedOptions: { tags: Tags; searchQuery: string; currentPage: number },
  filterTagChanged: (tags: Tags) => void
) => {
  const tagTitle = vacancyOverviewTagFilterTitle(tagType)
  const selected_tagItems = selectedOptions.tags.get(tagType).sort()

  const nonselected = tagValues.filter((v) => !selected_tagItems.includes(v))

  const newTagValues = [...selected_tagItems, ...nonselected]

  return (
    <li className="fo__items">
      <h3 className="fo__section text--m"> {t(`search:tag_${tagTitle.toLowerCase()}`)}</h3>
      <ul className="fo__list">
        {take(newTagValues, 4).map((tagValue) =>
          renderSingleCheckboxes(tagValue, tagType, tagTitle, selectedOptions, filterTagChanged)
        )}
        {newTagValues.length > 4 &&
          skip(newTagValues, 4).map((tagValue) =>
            renderSingleCheckboxes(
              tagValue,
              tagType,
              tagTitle,
              selectedOptions,
              filterTagChanged,
              ` fo__item--${tagTitle.toLowerCase()} ${btnShowMoreLocation ? '' : 'fo__item--hidden'}`
            )
          )}
      </ul>
      {tagValues.length > 4 && (
        <button
          id={`btn_${tagTitle.toLowerCase()}`}
          className="fo__toggle link link--secondary"
          onClick={() => {
            document.querySelectorAll(`.fo__item--${tagTitle.toLowerCase()}`).forEach((i) => {
              if (i.classList.contains('fo__item--hidden')) {
                i.classList.remove('fo__item--hidden')
                if (!btnShowMoreLocation) {
                  btnShowMoreLocation = true
                }
              } else {
                i.classList.add('fo__item--hidden')
                if (btnShowMoreLocation) {
                  btnShowMoreLocation = false
                }
              }
            })
            !btnShowMoreLocation
              ? (document.getElementById(`btn_${tagTitle.toLowerCase()}`).innerText = t('search:show_more'))
              : (document.getElementById(`btn_${tagTitle.toLowerCase()}`).innerText = t('search:show_less'))
          }}
        >
          {btnShowMoreLocation ? t('search:show_less') : t('search:show_more')}
        </button>
      )}
    </li>
  )
}
const renderVacancyOverviewCountryTagFilterCheckboxes = (
  tagValues: Array<string>,
  tagType: string,
  tagTitle: string,
  selectedOptions: { tags: Tags; searchQuery: string; currentPage: number },
  filterTagChanged: (tags: Tags) => void
) => {
  const selected_tagItems = selectedOptions.tags.get(tagType).sort()
  const nonselected = tagValues.filter((v) => !selected_tagItems.includes(v))

  const newTagValues = [...selected_tagItems, ...nonselected]

  return (
    <li className="fo__items">
      <h3 className="fo__section text--m"> {t(`search:tag_${tagTitle.toLowerCase()}`)}</h3>
      <ul className="fo__list">
        {take(newTagValues, 4).map((tagValue) =>
          renderSingleCheckboxes(tagValue, tagType, tagTitle, selectedOptions, filterTagChanged, '', true)
        )}
        {newTagValues.length > 4 &&
          skip(newTagValues, 4).map((tagValue) =>
            renderSingleCheckboxes(
              tagValue,
              tagType,
              tagTitle,
              selectedOptions,
              filterTagChanged,
              ` fo__item--${tagTitle.toLowerCase()} ${btnShowMoreCountry ? '' : 'fo__item--hidden'}`,
              true
            )
          )}
      </ul>
      {tagValues.length > 4 && (
        <button
          id={`btn_${tagTitle.toLowerCase()}`}
          className="fo__toggle link link--secondary"
          onClick={() => {
            document.querySelectorAll(`.fo__item--${tagTitle.toLowerCase()}`).forEach((i) => {
              if (i.classList.contains('fo__item--hidden')) {
                i.classList.remove('fo__item--hidden')
                if (!btnShowMoreCountry) btnShowMoreCountry = true
              } else {
                i.classList.add('fo__item--hidden')
                if (btnShowMoreCountry) btnShowMoreCountry = false
              }
            })
            !btnShowMoreCountry
              ? (document.getElementById(`btn_${tagTitle.toLowerCase()}`).innerText = t('search:show_more'))
              : (document.getElementById(`btn_${tagTitle.toLowerCase()}`).innerText = t('search:show_less'))
          }}
        >
          {btnShowMoreCountry ? t('search:show_less') : t('search:show_more')}
        </button>
      )}
    </li>
  )
}
const renderSingleCheckboxes = (
  tagValue: string,
  tagType: string,
  tagTitle: string,
  selectedOptions: { tags: Tags; searchQuery: string; currentPage: number },
  filterTagChanged: (tags: Tags) => void,
  extra_class_name?: string,
  translation: boolean = false
) => (
  <li
    className={`fo__item${extra_class_name ? extra_class_name : ''}`}
    key={`tag_${tagType.toLowerCase()}_${tagValue.toLowerCase()}`}
  >
    <label htmlFor={`check1 ${tagValue}`} className="fo__label">
      <span className="fo__label-copy text--m">
        {translation
          ? tagType == vacancyContract
            ? t(
                `search:tag_${tagValue
                  .replace('&', '_')
                  .replace(',', '_')
                  .replace('-', '_')
                  .replace('-', '_')
                  .split(/\s/)
                  .join('')
                  .toLowerCase()}`
              )
            : tagType == vacancyCountry
            ? t(
                `search:tag_countryname:${tagValue
                  .replace('&', '_')
                  .replace(',', '_')
                  .replace('-', '_')
                  .replace('-', '_')
                  .split(/\s/)
                  .join('')
                  .toLowerCase()}`
              )
            : t(
                `search:tag_${tagValue
                  .replace('&', '_')
                  .replace(',', '_')
                  .replace('-', '_')
                  .split(/\s/)
                  .join('')
                  .toLowerCase()}`
              )
          : tagValue}
      </span>
      <input
        id={`check1 ${tagValue}`}
        key={`check1 ${tagValue}`}
        type="checkbox"
        className="fo__checkbox"
        checked={selectedOptions.tags.get(tagType)?.includes(tagValue)}
        onClick={() => {
          datalayerHandler('filter_opdrachten', tagTitle, 'filter_opdrachten', { label: tagValue })
          const selected_tagItems = selectedOptions.tags.get(tagType)
          if (selected_tagItems.includes(tagValue))
            filterTagChanged(
              selectedOptions.tags.set(
                tagType,
                selected_tagItems.filter((t) => t != tagValue)
              )
            )
          else filterTagChanged(selectedOptions.tags.set(tagType, selected_tagItems.concat(tagValue)))
        }}
      />
    </label>
  </li>
)
